@if (items.length) {
  <div id="slider" class="life-cycle-slider">
    <swiper-container #swiper init="false">
      @for (item of items; track item) {
        <swiper-slide>
          <div class="slide">
            <div class="image-container">
              <img [src]="item.image" />
            </div>
            <div class="description-container">
              <p class="description">{{ item.image_description }}</p>
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>
    @if (!hideLeft) {
      <button (click)="slidePrev()" class="left-button">
        <i class="fas fa-chevron-left"></i>
      </button>
    }
    @if (!hideRight) {
      <button (click)="slideNext()" class="right-button">
        <i class="fas fa-chevron-right"></i>
      </button>
    }
  </div>
}
